import { useIntl } from 'react-intl';
export const useFileSizeFormatter = () => {
    const intl = useIntl();
    return (sizeInBytes) => {
        const sizeInKb = sizeInBytes / 1024;
        if (sizeInKb >= 1024) {
            const sizeInMb = sizeInKb / 1024;
            return `${sizeInMb.toFixed(2)} ${intl.formatMessage({ id: 'mb' })}`;
        }
        return `${sizeInKb.toFixed(2)} ${intl.formatMessage({ id: 'kb' })}`;
    };
};
